import gql from 'graphql-tag';
import FRAGMENTS from '_Resources/Cards/Services/GraphQl/FRAGMENTS';

const query = gql`
  query getSatisfactionNpsCardData(
    $projectId: Int!
    $range: DateRangeInput!
    $criteriaKeys: [CriteriaKey!]
    $thematics: [ThematicInput!]
    $keywords: [String!]
    $dataCollectorId: Int
  ) {
    results: getSatisfactionNpsCardData(
      projectId: $projectId
      range: $range
      criteriaKeys: $criteriaKeys
      thematics: $thematics
      keywords: $keywords
      dataCollectorId: $dataCollectorId
    ) {
      satisfaction {
        ...KpiResultsFragment
      }
      netPromoterScore {
        ...KpiResultsFragment
      }
      effort {
        ...KpiResultsFragment
      }
      recommendation {
        ...KpiResultsFragment
      }
    }
  }
  ${FRAGMENTS.kpiResults}
`;
export default query;
